<div class="bg" [ngClass]="bgClass">
  @if (isLoading | async) {
    <div class="overlay">
      <div class="ds2-preloader-wrapper">
        <div class="ds2-preloader">
        </div>
      </div>
    </div>
  }
</div>